import styled from '@emotion/styled';
import FileInputWithImage from '__components/Kizen/FileInputWithImage';
import { KizenTypography } from '__app/typography';
import Switch from '__components/Kizen/Switch';
import TextInput from '__components/Inputs/TextInput';

export const StyledTestExplanation = styled(KizenTypography)`
  background-color: var(--color-feedback-info-bg);
  padding: 10px;
  & strong {
    font-size: inherit;
  }
`;

export const StyledResponseError = styled(KizenTypography)`
  margin-top: 20px;
  color: var(--color-viz-cat-7-primary);
  background-color: var(--color-feedback-info-bg);
  padding: 10px;
  & strong {
    font-size: inherit;
  }
`;

export const StyledFilePicker = styled(FileInputWithImage)`
  text-align: start;
  & label {
    margin-top: 15px;
  }
  & input[type='file'] + span {
    width: 100%;
  }
`;
export const StyledFileName = styled(TextInput)`
  text-align: start;
  & label {
    margin-top: 15px;
  }
`;

export const StyledSwitch = styled(Switch)`
  margin-top: 15px;
`;

export const StyledSmartConnectorName = styled.span`
  max-width: 340px;
  display: inline-flex;
  font-size: inherit;
  line-height: inherit;
  & > span {
    font-weight: bold;
    font-size: inherit;
    line-height: inherit;
  }
`;

export const StyledUTF8BOMWarning = styled(KizenTypography)`
  color: var(--color-button-warning-hover);
  margin: 15px 0;
`;
